const keys=['lens','month','date','risk','topic','source','assetId'] as const;
export function calendarMonth(value:string|null, fallback:string) {
  return value&&/^\d{4}-(0[1-9]|1[0-2])$/.test(value)&&Number(value.slice(0,4))>=1900&&Number(value.slice(0,4))<=9998?value:fallback;
}
export function calendarHref(search:string,building?:string) {
  const source=new URLSearchParams(search),params=new URLSearchParams();
  if(building)params.set('building',building);
  for(const key of keys){const value=source.get(key);if(value&&value.length<=120)params.set(key,value);}
  return `/calendar${params.size?'?'+params:''}`;
}
export function privateCalendarSearch(state:unknown) {
  const value=state&&typeof state==='object'&&'calendarSearch' in state?state.calendarSearch:undefined;
  return typeof value==='string'?value.slice(0,120):'';
}
export function calendarReturnContext(state:unknown,building?:string) {
  if(!state||typeof state!=='object'||!('calendarReturn' in state))return undefined;
  const value=state.calendarReturn;
  if(!value||typeof value!=='object'||!('to' in value)||typeof value.to!=='string'||!value.to.startsWith('/calendar')||value.to.startsWith('//'))return undefined;
  const url=new URL(value.to,'https://staff.invalid');
  if(url.origin!=='https://staff.invalid'||url.pathname!=='/calendar'||url.hash)return undefined;
  if([...url.searchParams.keys()].some(key=>!['building',...keys].includes(key)||url.searchParams.getAll(key).length!==1))return undefined;
  if((url.searchParams.get('building')??undefined)!==building)return undefined;
  return {to:calendarHref(url.search,building),search:'search' in value&&typeof value.search==='string'?value.search.slice(0,120):'',
    focusKey:'focusKey' in value&&typeof value.focusKey==='string'?value.focusKey.slice(0,200):''};
}
export function calendarRowId(key:string){return `calendar-${encodeURIComponent(key)}`;}
